var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavBuilding2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.391,
    height: 20.118,
    viewBox: "0 0 21.391 20.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#b1b1c9;stroke:#b1b1c9;stroke-width:.3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_buildings_1022197",
    transform: "translate(-192.477 -153.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1604",
    d: "M199.949 164.032h-1.7a.244.244 0 0 0-.258.229.164.164 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.374H198.5v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-.75 -1.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1605",
    d: "M211.339 164.032h-1.7a.244.244 0 0 0-.258.229v2.429a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.374h-1.187v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-2.342 -1.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1606",
    d: "M199.949 169.521h-1.7a.244.244 0 0 0-.258.229.164.164 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.4H198.5v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-.75 -2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1607",
    d: "M211.339 169.521h-1.7a.244.244 0 0 0-.258.229v2.429a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.4h-1.187v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-2.342 -2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1608",
    d: "M199.949 158.6h-1.7a.244.244 0 0 0-.258.229.164.164 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.4H198.5v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-.75 -.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1604-2",
    d: "M205.644 164.032h-1.7a.244.244 0 0 0-.258.229.167.167 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.161.161 0 0 0 0-.029v-2.4a.244.244 0 0 0-.228-.258h-.03zm-.258 2.374H204.2v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-1.546 -1.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1606-2",
    d: "M205.644 169.521h-1.7a.244.244 0 0 0-.258.229.167.167 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.161.161 0 0 0 0-.029v-2.4a.244.244 0 0 0-.228-.258h-.03zm-.258 2.4H204.2v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-1.546 -2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1608-2",
    d: "M205.644 158.6h-1.7a.244.244 0 0 0-.258.229.167.167 0 0 0 0 .029v2.4a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.161.161 0 0 0 0-.029v-2.4a.244.244 0 0 0-.228-.258h-.03zm-.258 2.4H204.2v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-1.546 -.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1609",
    d: "M211.339 158.6h-1.7a.244.244 0 0 0-.258.229v2.429a.245.245 0 0 0 .229.258h1.732a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-2.4a.243.243 0 0 0-.228-.258h-.03zm-.258 2.4h-1.187v-1.884h1.187z",
    className: "cls-1",
    transform: "translate(-2.342 -.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1610",
    d: "M211.817 172.533V156.69h.077a.244.244 0 0 0 .258-.228.164.164 0 0 0 0-.029v-1.548a.243.243 0 0 0-.228-.258h-2.662v-1.137a.243.243 0 0 0-.228-.258h-11.547a.244.244 0 0 0-.258.229.164.164 0 0 0 0 .029v1.135h-2.581a.244.244 0 0 0-.258.229.164.164 0 0 0 0 .029v1.548a.245.245 0 0 0 .229.258h.132v15.843h-1.867a.258.258 0 1 0 0 .516h20.574a.258.258 0 1 0 0-.516h-1.642zm-14.072-18.785h11v.877h-11zm-2.813 1.393h16.73v1.032h-16.73zm.335 1.548H211.3v15.843h-16.031z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBuilding2);
export default __webpack_public_path__ + "static/media/nav-building-2.d4d095cd1b7c5bc7ac9311f55833c382.svg";
export { ForwardRef as ReactComponent };